import { LotacaoEditableTableModel } from 'components/form/editable-table/LotacaoEditableTable'
import { Cidadao } from 'graphql/types.generated'

import { CidadaoGrupoItemModel, LotacaoGrupoItemModel } from './componentes/AtividadeColetivaGrupoSelectField'
import { ParticipanteEditableTableModel } from './componentes/participantes/ParticipanteEditableTable'
import {
  AtividadeColetivaReuniaoModel,
  AtividadeColetivaSaudeModel,
  AtividadePseModel,
  ParticipanteModel,
} from './model-atividadeColetiva'

type CidadaoNome = Pick<Cidadao, 'nome' | 'nomeSocial'>

export const getNomeCidadao = (model?: Partial<CidadaoNome>) => model?.nomeSocial ?? model?.nome

export const sortByNomeCidadao = (a: { cidadao: CidadaoNome }, b: { cidadao: CidadaoNome }) =>
  getNomeCidadao(a.cidadao).localeCompare(getNomeCidadao(b.cidadao))

const getNomeParticipante = (model: ParticipanteModel) =>
  getNomeCidadao(model.cidadao) ?? model.cidadaoParticipante.nome ?? 'ZZZ'

const getDataNascimentoParticipante = (model: ParticipanteModel) =>
  new Date(model.cidadao?.dataNascimento ?? model.cidadaoParticipante?.dataNascimento).getTime()

const compareDataNascimento = (a: ParticipanteModel, b: ParticipanteModel) => {
  const dataA = getDataNascimentoParticipante(a)
  const dataB = getDataNascimentoParticipante(b)
  return dataA < dataB ? 1 : dataA > dataB ? -1 : 0
}

export const sortByNomeAndIdadeParticipante = (a: ParticipanteModel, b: ParticipanteModel) =>
  10 * getNomeParticipante(a).localeCompare(getNomeParticipante(b)) + compareDataNascimento(a, b)

export const hasDataNascimentoAfterDataAtividade = (
  dataAtividade: LocalDate | Instant,
  dataNascimento: LocalDate | Instant
): boolean => !!dataNascimento && !!dataAtividade && new Date(dataNascimento) > new Date(dataAtividade)

export const isPse = (model: { atividadePse?: AtividadePseModel }): boolean =>
  model.atividadePse?.educacao || model.atividadePse?.saude

export const getLocalAtividade = (atividadeColetiva: AtividadeColetivaSaudeModel | AtividadeColetivaReuniaoModel) => {
  if (atividadeColetiva.inepLocalAtividade) {
    const { nomeEstabelecimento, dsInep } = atividadeColetiva.inepLocalAtividade
    return `INEP - ${nomeEstabelecimento ?? dsInep}`
  }

  if (atividadeColetiva.unidadeSaudeLocalAtividade) {
    const { cnes, nome } = atividadeColetiva.unidadeSaudeLocalAtividade
    return `CNES - ${nome ?? cnes}`
  }

  return atividadeColetiva.outraLocalidade
}

export const filterLotacoesFromGrupo = (
  lotacoesFromGrupo: LotacaoGrupoItemModel[],
  currentLotacoesEnvolvidas: LotacaoEditableTableModel[]
): LotacaoGrupoItemModel[] => {
  const currentLotacoesIds = new Set(currentLotacoesEnvolvidas.map((lotacaoEnvolvida) => lotacaoEnvolvida.lotacao?.id))

  return lotacoesFromGrupo.filter((lotacao) => !currentLotacoesIds.has(lotacao.id))
}

export const filterCidadaosFromGrupo = (
  cidadaosFromGrupo: CidadaoGrupoItemModel[],
  currentParticipantes: ParticipanteEditableTableModel[]
): CidadaoGrupoItemModel[] => {
  const currentCidadaosIds = new Set(currentParticipantes.map((participante) => participante.cidadao?.id))

  return cidadaosFromGrupo.filter((cidadao) => !currentCidadaosIds.has(cidadao.id))
}

export const getMensagemGrupoAdicionado = (
  nomeGrupo: string,
  qtdProfissionais: number,
  qtdParticipantes: number = 0
): string => {
  const profissionaisText = qtdProfissionais === 1 ? `1 profissional` : `${qtdProfissionais} profissionais`
  const participantesText = qtdParticipantes === 1 ? `1 participante` : `${qtdParticipantes} participantes`

  const itensText = qtdParticipantes > 0 ? `${profissionaisText} e ${participantesText}` : profissionaisText

  const verboText = qtdProfissionais === 1 && qtdParticipantes === 0 ? 'foi adicionado' : 'foram adicionados'

  return `Vínculo com o grupo ${nomeGrupo} efetuado com sucesso, ${itensText} ${verboText} à atividade.`
}
